export enum ClientType {

	PF = 1,
	PJ = 2,
	PF_PJ = 3

}
